import { createSlice } from "@reduxjs/toolkit";


const cartSlice=createSlice({
name:'cart',
initialState:[],
reducers:{

    addToCart(state, action) {
        const { id } = action.payload;
        const existingItem = state.find(item => item.id === id);
        if (existingItem) {
          // If item exists, increase qty by 1
          return state.map(item => {
            if (item.id === id) {
              return { ...item, qty: item.qty + 1 };
            }
            return item;
          });
        } else {
          // If item doesn't exist, add it with qty 1
          
          return [...state, { ...action.payload, qty: 1 }];
          

        }
      },
plusQty(state,action){
  const item = state.find(item => item.id === action.payload);
  if(item){
  
     
        item.qty += 1;
      
  }
}
,
minusQty(state,action){

  
  const item = state.find(item => item.id === action.payload);
  if(item){
  
      if (item && item.qty > 1) {
        item.qty -= 1;
      }
  }
},
clearCart(state){
 return state=[];

}



,
removeFromCart(state, action) {

 
    const {id} = action.payload;
    return state.filter(item => item.id !== id);
  },

}



})

export const {addToCart,removeFromCart,plusQty,minusQty,clearCart}=  cartSlice.actions;
export default cartSlice.reducer